import { EntityType } from '@/types';
import { agentEntities } from './agent.entity';
import { brandEntities } from './brand.entity';
import { productEntities } from './product.entity';
import { showroomEntities } from './showroom.entity';
import { storageEntities } from './storage.entity';

export const entities: EntityType = {
  showroomEntities,
  storageEntities,
  productEntities,
  brandEntities,
  agentEntities,
};
